import _ from "lodash";
import ko from "knockout";

/**
 * <p>Binding handler for rendering localized number strings. Parameters are:</p>
 * <dl>
 *  <dt>number</dt>
 *  <dd>the number to format in the current locale</dd>
 *  <dt>format</dt>
 *  <dd>the globalize format to use. Default is 'n0'. More explaination here: https://github.com/jquery/globalize/tree/79ae658b842f75f58199d6e9074e01f7ce207468#numbers</dd>
 *  <dt>locale</dt>
 *  <dd>the locale to use. Default is current locale</dd>
 *</dl>
 * <pre class="prettyprint">
 * &lt;span data-bind="lNumber: {number: myValue, format: "n0"}"&gt;
 * &lt;/span&gt;
 * </pre>
 *
 * @exports extensions/i18n/knockout-lNumber
 */
ko.bindingHandlers.lNumber = {
    init: function () {},
    update: function (element, valueAccessor) {
        let number, format, locale;
        const numberInfo = ko.utils.unwrapObservable(valueAccessor());

        if (_.isNumber(numberInfo) && !_.isNaN(numberInfo)) {
            number = numberInfo;
            format = "n0";
        } else if (_.isPlainObject(numberInfo)) {
            number = numberInfo.number;
            format = numberInfo.format || "n0";
            locale = numberInfo.locale;
        } else {
            throw "An object or number object must be provided to bind lNumber.";
        }

        element.innerHTML = ko.i18n.formatNumber(number, format, locale);
    },
};

export default ko.bindingHandlers.lNumber;
